import React, { memo, useState, useRef } from 'react';

import { Handle } from 'react-flow-renderer';
import  './nodeStyles';
import plus from '../img/plus.png';
import minus from '../img/minus.png';
import loop from '../img/loop.png';

import LoopNode from './LoopNode';
import DesignCard from './DesignCard';
import LoopIcon from '@material-ui/icons/LoopTwoTone';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons'


import ReactFlow, {
  ReactFlowProvider,
  addEdge,
  removeElements,
  Controls, Background
} from 'react-flow-renderer';  


export default memo(({ data }) => {

  const designerIconStyle = {
    // backgroundImage:'linear-gradient(to bottom, grey, royalblue)', color:'white', padding:'5px', borderRadius:'25px', marginLeft:'10px'
    padding:'0px', color:'royalblue', borderRadius:'20px', marginTop:'10px', marginLeft:'10px', marginRight:'10px'
}

  const reactFlowWrapper = useRef(null);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
    const [mystate, setMyState] = useState(0)
  const[ exco, setIcon] = useState(plus)

  const [height, setHeight] = useState(150)
  var style = {
      background:'lightpink',
      color:'red',
      textAlign:'center',
      width:50,
      height:{height},
  
  
  } 

  const  imageClick = () => {
      if (mystate == 0) {
          setIcon ( minus )
          setMyState(1)
          setHeight (600); 
      }
      else if (mystate == 1) {
          setMyState(0)
          setHeight (100); 
          setIcon ( plus )
      }
  }

  const renderContent = (yPos) => {
    return
    if (mystate == 0) {return}

    return (

      <ReactFlowProvider>

      <div style={istyle} className="reactflow-wrapper" ref={reactFlowWrapper}>
              <ReactFlow
                  style={style}
                  elements={elements}
                  nodeTypes={nodeTypes}
                  onConnect={onConnect}
                  onElementsRemove={onElementsRemove}
                  // onLoad={onLoad}
                  // onDrop={onDrop}
                  // onDragOver={onDragOver}
                  // onElementClick={onElementClick}
              >
                  <Controls />
                  <Background variant="dots" color="gray" gap={10} /> 

              </ReactFlow>

          </div>
    </ReactFlowProvider>



    );
    
}

const initialElements = [
  {
    id: '1',
    type: 'input',
    data: { label: 'Begin' },
    position: { x: 250, y: 30 },
    style: {
      background: 'beige',
      color: 'black',
      border: '1px solid #222138',
      width: 200,
    },
  },
  {
    id: '2',
    type: 'output',
    data: { label: 'End' },
    position: { x: 250, y: 500 },
    style: {
      background: 'beige',
      color: 'black',
      border: '1px solid #222138',
      width: 200,
    },
  },

];


const [elements, setElements] = useState(initialElements);
const onConnect = (params) => setElements((els) => addEdge(params, els));
const onElementsRemove = (elementsToRemove) =>
  setElements((els) => removeElements(elementsToRemove, els));



const nodeTypes = {
  LoopNode: LoopNode,
};

const istyle = {
  width:200, 
  height:600,
}
var displayLabel= data.label + ":" + data.attributes["BizName"]

const renderImage = () => {
  if (data.attributes.image == undefined || data.attributes.image == null || data.attributes.image=='')
  return (<div/>)
  else
  {
    var baseURL = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/bots/image/'
    if (data.objectType == 'TASK') 
    {
      console.log("Task Type object")
      baseURL = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/tasks/image/'

    }
    else if (data.objectType == 'SUBTASK') 
    {
      console.log("SubTask Type object")
      baseURL = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/subtasks/image/' + data.parentObjectType  + '/' + data.parentEntityName + '/'
    }

    const url = baseURL + data.entity +'/' + data.attributes.image

    return (
        <img className='clickimage'  src={url} ></img>
  );
  }

}


  return (
    <div className="designnode">
      <Handle
        type="target"
        position="top"
        style={{ background: '#555' }}
        onConnect={(params) => console.log('handle onConnect', params)}
      />
      {/* <img src={exco} width='20' height='20' onClick={imageClick}></img> */}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <FontAwesomeIcon icon={faSyncAlt} style={designerIconStyle} size='1x'/>
        <br/>
        {renderImage()}      
      </div>
      <DesignCard attributes={data.attributes} name={data.label}/>

      {renderContent()}

      <Handle
        type="source"
        position="bottom"
        id="l2"
        style={{ bottom: -10, top: 'auto', background: '#555' }}
      />
    </div>
  );
});